import React from 'react'
import { useTranslation } from 'react-i18next'
import { MyTextField } from './MyTextField'

interface SingleDateFieldErrorStrings {
  required: string
  invalid: string
}

interface MyDateFieldProps {
  variableInputName: string;
  shouldUnregister?: boolean;
  legendHeader?: React.ReactElement;
  removeDayField?: boolean;
  className?: string;
  fieldErrorStrings: {
    month: SingleDateFieldErrorStrings,
    day: SingleDateFieldErrorStrings,
    year: SingleDateFieldErrorStrings
  };
  dashLineEndingEnabled?: boolean;
  isCurrentlyValid?: any;
  'aria-describedby'?: string
}

export const MyDateField: React.FC<MyDateFieldProps> = ({
  variableInputName,
  legendHeader,
  removeDayField = false,
  className,
  fieldErrorStrings,
  dashLineEndingEnabled,
  isCurrentlyValid,
  shouldUnregister,
  ...props
}) => {
  const { month, day, year } = fieldErrorStrings
  // TODO - this translation is not specific to mcfStep1page? Needs more generic file
  const { t } = useTranslation('mcfStep1Page')
  // TODO - this translation is not specific to mcfStep1page? Needs more genereic file

  return (
    <fieldset
      className='ds-c-fieldset'
      aria-describedby={props['aria-describedby']}
    >
      {legendHeader}
      <div className='ds-l-form-row ds-u-align-items--start'>
        <div className='ds-l-col--auto'>
          <MyTextField
            isCurrentlyValid={isCurrentlyValid}
            name={`${variableInputName}.month`}
            data-testid={`${variableInputName}.month`}
            label={t('MONTH')}
            fieldClassName={className + ' my-c-field--month'}
            labelClassName='ds-c-datefield__label'
            errorMessageClassName='my-u-max-width--75'
            rules={{
              required: { value: true, message: month.required },
              maxLength: 2,
              min: { value: 1, message: month.invalid },
              max: { value: 12, message: month.invalid }

            }}
            autoComplete='bday-month'
            inputMode='numeric'
            pattern='[0-9]*'
            maxLength={2}
            shouldUnregister={shouldUnregister}
          />
        </div>
        {!removeDayField &&
          <>
            <span className='ds-c-datefield__separator my-u-display--inline ds-u-margin-top--6'>/</span>
            <div className='ds-l-col--auto'>
              <MyTextField
                isCurrentlyValid={isCurrentlyValid}
                name={`${variableInputName}.day`}
                data-testid={`${variableInputName}.day`}
                label={t('DAY')}
                fieldClassName={className + ' my-c-field--day'}
                labelClassName='ds-c-datefield__label'
                errorMessageClassName='my-u-max-width--75'
                rules={{
                  required: { value: true, message: day.required },
                  maxLength: 2,
                  min: { value: 1, message: day.invalid },
                  max: { value: 31, message: day.invalid }
                }}
                autoComplete='bday-day'
                inputMode='numeric'
                pattern='[0-9]*'
                maxLength={2}
                shouldUnregister={shouldUnregister}
              />
            </div>
          </>}
        <span className='ds-c-datefield__separator my-u-display--inline ds-u-margin-top--6'>/</span>
        <div className='ds-l-col--auto'>
          <MyTextField
            isCurrentlyValid={isCurrentlyValid}
            name={`${variableInputName}.year`}
            data-testid={`${variableInputName}.year`}
            label={t('YEAR')}
            fieldClassName={className + ' my-c-field--year'}
            labelClassName='ds-c-datefield__label'
            errorMessageClassName='my-u-max-width--75'
            rules={{
              required: { value: true, message: year.required },
              maxLength: 4,
              min: { value: 1900, message: year.invalid }
            }}
            autoComplete='bday-year'
            inputMode='numeric'
            pattern='[0-9]*'
            maxLength={4}
            shouldUnregister={shouldUnregister}
          />
        </div>
        {dashLineEndingEnabled && <span className='ds-c-datefield__separator my-u-display--inline ds-u-margin-top--6'>-</span>}

      </div>
    </fieldset>
  )
}
